<template>
  <div class="page repayment-detail">
    <navigation>借款详情</navigation>
    <div class="tips"
         @click="goWithdraw"
         data-sensors-exposure-property-element_positon="banner"
         data-sensors-exposure-event-name="Element_Exposure"
         :data-sensors-exposure-property-element_type="tips.banner.textKey"
         v-if="tips && tips.banner && tips.banner.text"
    ><img src="./images/icon@2x.png"> {{ tips.banner.text }}</div>

    <!-- api 老用户 用户引导关注的 banner -->
    <guideApiFollow placeEnum="LOAN_DETAIL"></guideApiFollow>
    <div class="repayment-info">
      <nd-cell
        class="repayment-info-item"
        :arrow="false"
        title="借款金额 (元)"
      >
        <span slot="text">{{ totalRepaymentAmount | currency }}</span>
      </nd-cell>

      <nd-cell
        class="repayment-info-item"
        :arrow="false"
        title="借款生效日"
      >
        <span slot="text">{{
          creditStartTime | date('YYYY/MM/DD')
        }}</span>
      </nd-cell>

            
      <!-- 天美贷不显示借款分期 -->
      <nd-cell
        v-if="loanPlatform !== 'TMD'"
        class="repayment-info-item"
        :arrow="false"
        title="借款平台"
      >
        <span slot="text">{{ loanPlatform | platform }}</span>
      </nd-cell>

      <nd-cell
        class="repayment-info-item"
        :arrow="false"
        title="放款借据"
      >
        <span slot="text" class="orderId" disabled="true">{{orderId}}</span>
      </nd-cell>

      <nd-cell
        v-if="!auditAccountMockOrderIds.includes(orderId)"
        @click="goRelateProtocol"
        class="repayment-info-item"
        title="相关协议"
      />
    </div>
    <div class="repayment-schedule">
      <div class="cell-title">
        还款计划<em>（共{{ scheduleList.length }}期）</em>
      </div>

      <div class="schedule-list">
        <table>
          <tr class="table-header">
            <th width="15%">期数</th>
            <th width="24%">还款日</th>
            <th width="23%">应还金额</th>
            <th width="23%">剩余应还</th>
            <th width="15%">状态</th>
          </tr>
          <tr
            class="table-row"
            :class="[
              item.termStatus.toLowerCase(),
              termNo === item.repaymentIndex && 'now',
            ]"
            v-for="(item, index) in scheduleList"
            :key="index"
          >
            <td>
              {{ item.repaymentIndex }}/{{ scheduleList.length }}
            </td>
            <td>
              {{ item.repaymentDueDate | date('YYYY/MM/DD') }}
            </td>
            <td>{{ item.schdAmt | currency }}</td>
            <td>{{ item.repaymentDueTotal | currency }}</td>
            <td>{{ item.termStatus | status }}</td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 从借款历史进来的不显示按钮 -->
    <div class="footer" v-if="!from">
      <nd-button
        class="btn"
        @click="openSelectPopup"
        :disabled="!canRepay||!!buttonStatus.isDisabled"
        :loading="buttonStatus.loading"
      >{{ buttonStatus.text }}</nd-button>
    </div>
    <select-popup
      ref="selectPopup"
      :scheduleList="scheduleList"
      :loanPlatform="loanPlatform"
      :productCd="productCd"
      :fundCode="fundCode"
      :orderId="orderId"
      :canOffLineRepay="canOffLineRepay"
      :canOnlyRepayAll="canOnlyRepayAll"
      :termNo="termNo"
      :canConsultRepay="canConsultRepay"
    ></select-popup>

    <!-- 返回首页 -->
    <back-home-drag y="13"></back-home-drag>

  </div>
</template>
<script>
import SelectPopup from './components/select'
import { mapActions } from 'vuex'
import { getKey, isWxMiniprogram, isTMDIOSApp } from '../../assets/utils'
export default {
  name: 'repayment-detail',
  customReadyNotify: true,
  components: { 
    SelectPopup,
    guideApiFollow: () => import('@/components/guide-api-follow/index.vue')
  },

  data () {
    return {
      showBackHomeDrag: false,
      orderId: this.$route.query.orderId,
      query: this.$route.query || {},
      totalRepaymentAmount: 5000,
      creditStartTime: Date.now(),
      loanPlatform: this.$route.query.loanPlatform,
      agreementUrl: '',
      fundCode: 'WUJIE',
      productCd: this.$route.query.productCd,
      scheduleList: [],
      canRepay: true,
      onLineRepayInProcess: false, // 当前订单是否在线上还款中（true 线上还款中）
      offLineRepayInProcess: false, // 当前订单是否在处于线上还款中（true 线下还款中）
      dueDate: '',
      canRepayDate: '',
      termNo: 0,
      canOffLineRepay: false,
      canOnlyRepayAll: false,
      from: this.$route.query.from === 'true',
      consultRepayInProcess: false, // 此订单是否在申请展期受理中
      canConsultRepay: false, // 是否是申请展期订单
      showMao: false, // 是否展示猫
      tips: {},
      auditAccountMockOrderIds: ['PLCN2024112074155304QSK7WZDL9330']// 应用市场审核时，模拟的借据号，需要隐藏相关协议
    }
  },

  async created () {
    this.getLoanBilltip()
    await this.getOrderDetail()
    this.$bus.$emit('ready')
  },

  filters: {
    status (value) {
      const mapping = {
        U: '待还',
        O: '逾期',
        S: '已还',
        J: '还款中',
        R: '对账中'
      }
      return mapping[value]
    },

    platform (value) {
      const platform = getKey('platform')
      const result = platform.find(item => item.loanPlatform === value)
      if (result) {
        return result.loanPlatformName
      }
      return platform['TMD'] && platform['TMD'].loanPlatformName
    }
  },

  computed: {
    buttonStatus () {
      if (this.canConsultRepay) {
        return this.isApiH5 ? { text: '业务受理中', loading: false, isDisabled: true } : { text: '申请展期', loading: false }
      } else if (this.consultRepayInProcess) {
        return { text: '申请展期中...', loading: true, isDisabled: true }
      } else if (this.canRepay) {
        return { text: '去还款', loading: false }
      } else {
        if (this.onLineRepayInProcess && !this.offLineRepayInProcess) {
          // 线上还款中
          return { text: '还款受理中', loading: true }
        }
        if (this.offLineRepayInProcess && !this.onLineRepayInProcess) {
          // 线下还款中
          return { text: '还款受理中', loading: true }
        } else {
          return { text: this.formatDate(this.canRepayDate, 'M月D日可还款'), loading: false }
        }
      }
    }
  },

  methods: {
    ...mapActions('order', ['getOrderDetailX', 'loanBillTipX']),
    goWithdraw () {
      this.$sensors.track('$WebClick', { element_type: this.tips.banner.textKey })
      this.$router.push('/middle/limit')
    },
    async getLoanBilltip () {
      const { success, data } = await this.loanBillTipX({
        popType: 'MY_LOAN_DETAIL'
      })
      if (success) {
        this.tips = data
      }
    },
    goRelateProtocol () {
      const params = {
        loanPlatform: this.loanPlatform,
        orderId: this.$route.query.orderId,
        fundCode: this.fundCode
      }
      this.$router.push({ path: '/protocol', query: params })
    },

    openSelectPopup () {
      if (isTMDIOSApp() && this.canConsultRepay) {
        this.$message('请前往天美贷公众号进行申请展期', 2000)
      } else if (isWxMiniprogram() && this.canConsultRepay) {
        this.$message('请前往天美贷App或公众号进行申请展期', 2000)
      } else if (this.canConsultRepay) {
        this.$router.push(`/repayment/consult?orderId=${this.orderId}&loanPlatform=${this.loanPlatform}`)
      } else {
        this.$refs.selectPopup.open()
      } 
    },

    async getOrderDetail () {
      const response = await this.getOrderDetailX(this.query)
      if (response.success === true) {
        this.totalRepaymentAmount = response.data.totalRepaymentAmount
        this.creditStartTime = response.data.creditStartTime
        this.loanPlatform = response.data.loanPlatform
        this.agreementUrl = response.data.agreementUrl
        this.fundCode = response.data.fundCode
        this.scheduleList = response.data.terms
        this.canRepay = response.data.canRepay
        this.offLineRepayInProcess = response.data.offLineRepayInProcess
        this.onLineRepayInProcess = response.data.onLineRepayInProcess
        this.dueDate = response.data.dueDate
        this.canRepayDate = response.data.canRepayDate
        this.termNo = response.data.termNo
        this.canOffLineRepay = response.data.canOffLineRepay
        this.canOnlyRepayAll = response.data.canOnlyRepayAll
        this.canConsultRepay = response.data.canConsultRepay
        this.consultRepayInProcess = response.data.consultRepayInProcess
        if (!this.consultRepayInProcess && !this.canConsultRepay) {
          this.showMao = true
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page.repayment-detail {
    background-color: #fafafa;
    padding-bottom: 210px;
    .tips {
      display: flex;
      height: 80px;
      background: #FFECE4;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #B13314;
      align-items: center;
      img {
        width: 64px;
        margin-right: 10px;
        margin-left: 24px;
      }
    }
    .repayment-info {
        margin-top: 20px;

        .repayment-info-item {
            padding: 0 30px;
            border-bottom: 1px solid @iuc;

            .nd-cell-header {
                padding: 0;
            }

            .text {
                font-size: 30px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
            }

            .orderId{
              border:none; 
              background:none;
              text-align: right;
              font-size: 0.3rem;
            }
        }
    }

    .repayment-schedule {
        padding: 0 30px;

        .cell-title {
            font-size: 32px;
            height: 50px;
            line-height: 50px;
            margin-top: 40px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;

            em {
                font-size: 26px;
                font-style: normal;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: @fc3;
            }
        }

        .schedule-list {
            margin-top: 22px;
            padding-bottom: 20px;
            background-color: #ffffff;

            table {
                width: 100%;
                border-spacing: 0px;

                .table-header {
                    th {
                        font-size: 27px;
                        height: 50px;
                        line-height: 50px;
                        padding-top: 23px;
                        padding-bottom: 7px;
                        border-bottom: 1px solid @iuc;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    }
                }

                .table-row {
                    td {
                        height: 50px;
                        line-height: 50px;
                        font-size: 22px;
                        padding-top: 10px;
                        text-align: center;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    }

                    & + .table-row {
                        td {
                            padding-top: 2px;
                        }
                    }

                    &.s {
                        color: @fc3;
                    }

                    &.o {
                        color: @fc-error;
                    }

                    &.p {
                        color: #4b94f0;

                        td {
                            background-color: #ecf8ff;
                        }
                    }

                    &.r {
                        color: #f1591d;
                    }

                    &.now {
                        color: #4b94f0;

                        td {
                            background-color: #ecf8ff;
                        }

                        &.r {
                            color: #f1591d;

                            td {
                                background-color: #fffdf7;
                            }
                        }

                        &.s {
                            color: @fc3;

                            td {
                                background-color: #ffffff;
                            }
                        }
                        &.o {
                            color: @fc-error;

                            td {
                                background-color: #fff7f7;
                            }
                        }
                    }
                }
            }
        }
    }

    .footer {
        width: 750px;
        margin-left: -375px;
        height: 180px;
        background-color: #fff;
        position: fixed;
        bottom: 0;
        left: 50%;

        .btn {
            margin: 0 auto;
            margin-top: 28px;
        }
    }
}
</style>
